import { render, staticRenderFns } from "./FeaturedAboutUs.vue?vue&type=template&id=61d44a9a&scoped=true&"
import script from "./FeaturedAboutUs.vue?vue&type=script&lang=js&"
export * from "./FeaturedAboutUs.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedAboutUs.vue?vue&type=style&index=0&id=61d44a9a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d44a9a",
  null
  
)

export default component.exports